<script lang="ts">
import { slide } from 'svelte/transition'

import { _ } from '../i18n.svelte'

export let message = ''
export let hash = ''
export let hashTag = ''

export let isShowInstructions = true

$: count = (message + '\n#' + hash + '\n' + hashTag).length
</script>
<template lang="pug">
.message-card__wrapper
    .message-card__content__area
        .message-card__content-header__area
            .message-card__content-icon__empty
            .message-card__content-dummy-profile__text
                p.message-card__content-dummy-name__text Your Name
                p.message-card__content-dummy-id__text @your_id
        .message-card__content-text__area(class="{isShowInstructions ? 'active-instruction' : ''}")
            p.message-card__content-text-message__text.__font-color__blue
                | { message }
            p.message-card__content-text-hash__text.__font-color__red
                | \#{ hash }
            p.message-card__content-text-hash-tag__text
                | { hashTag }
    .message-card__text-counter__text
        | { count }
    +if('isShowInstructions')
        .message-card__instructions__area(transition:slide)
            p.__font-color__blue
                | ① {_('instructions_1', '')}
            p.__font-color__red
                | ② {_('instructions_2', '')}
            p
                | ③ {_('instructions_3', '')}
</template>
<style lang="scss">
.message-card__wrapper {
    .message-card__content__area {
        padding: 3% 3% 3% 4%;
        border: 1px solid var(--color-border-line);
        border-radius: 10px;
        .message-card__content-header__area {
            width: 100%;
            display: flex;
            align-items: flex-start;
            gap: 2%;
            .message-card__content-icon__empty {
                width: 50px;
                padding: 50px 0 0;
                border-radius: 50%;
                background-color:  var(--color-twitter);
            }
            .message-card__content-dummy-name__text {
                font-weight: bold;
            }
            .message-card__content-dummy-id__text {
                color: #c4c4c4;
            }
        }
        .message-card__content-text__area {
            margin: 3% 0 0 0;
            color: #111111;
            font-size: 1rem;
            white-space: pre-wrap;
            word-break: break-all;
            .message-card__content-text-message__text {
                position: relative;
                font-weight: bold;
            }
            .message-card__content-text-hash__text {
                position: relative;
                font-weight: bold;
            }
            .message-card__content-text-hash-tag__text {
                position: relative;
                color: var(--color-font-default);
            }
            &.active-instruction {
                .message-card__content-text-message__text,
                .message-card__content-text-hash__text,
                .message-card__content-text-hash-tag__text {
                    &::before {
                        width: 1rem;
                        height: 1rem;
                        position: absolute;
                        top: 0;
                        left: 0;
                        transform: translate(-100%, -10%);
                        font-size: .8rem;
                    }
                }
                .message-card__content-text-message__text {
                    &::before {
                        content: '①';
                    }
                }
                .message-card__content-text-hash__text {
                    &::before {
                        content: '②';
                    }
                }
                .message-card__content-text-hash-tag__text {
                    &::before {
                        content: '③';
                    }
                }
            }
        }
    }
    .message-card__text-counter__text {
        margin: 0 10px 0;
        text-align: right;
    }
    .message-card__instructions__area {
        font-size: 0.9rem;
    }
}
</style>